import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

// Upload one image to the planner program and return its storage path.
export function PhotoUpload({ onDone, label = "Add photo", testid, endpoint = "/planner-program/upload" }) {
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", f); const { data } = await api.post(endpoint, fd); onDone(data); } catch (er) { toast.error(formatApiError(er)); }
    setBusy(false);
  };
  return (
    <label className="btn-outline-gold !py-1.5 text-xs cursor-pointer" data-testid={testid}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ImagePlus className="w-3.5 h-3.5" />}{label}
      <input type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={pick} />
    </label>
  );
}

export const fileUrl = (p) => (!p ? "" : p.startsWith("http") || p.startsWith("/api/") ? p : `/api/files/${p}`);

export function useApi(path) {
  const [d, setD] = useState(null);
  const load = () => api.get(path).then((r) => setD(r.data)).catch((e) => setD({ error: formatApiError(e) }));
  useEffect(() => { load(); }, [path]); // eslint-disable-line react-hooks/exhaustive-deps
  return [d, load, setD];
}
